import { booleanPointInPolygon, union, difference, multiPolygon, polygon, featureCollection } from '@turf/turf'

export const isPointInsideFeature = (latlng, feature) => {
  const point = [latlng.lng, latlng.lat]
  return booleanPointInPolygon(point, feature)
}

export const getPolygonUnion = (newLayer, oldPolygon) => {
  let newPolygon
  if (newLayer.geometry.type === 'MultiPolygon') {
    newPolygon = multiPolygon(newLayer.geometry.coordinates)
  } else {
    newPolygon = polygon(newLayer.geometry.coordinates)
  }

  return union(featureCollection([oldPolygon, newPolygon]))
}

export const getPolygonDiff = (newlayer, oldPolygon) => {
  let newPolygon
  if (newlayer.geometry.type === 'MultiPolygon') {
    newPolygon = multiPolygon(newlayer.geometry.coordinates)
  } else {
    newPolygon = polygon(newlayer.geometry.coordinates)
  }
  return difference(featureCollection([oldPolygon, newPolygon]))
}



// WEBPACK FOOTER //
// ./src/components(new)/UI/Maps/core/utils.js